// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GZlP","col":"styles_col__3hGfU"};